export enum CompanySettingName {
  ShowAsAnonymous = "showAsAnonymous"
}
